export default "__VITE_ASSET__659600da__"